module.exports = __webpack_public_path__ + "static/media/UpdatesSocial.eced3cb8.jpg";